import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requirePermission }) {
  const { user, hasPermission } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background text-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requirePermission && !hasPermission(requirePermission)) {
    return (
      <div className="flex h-[60vh] flex-col items-center justify-center gap-2 text-center">
        <h2 className="text-2xl font-semibold">403</h2>
        <p className="text-sm text-muted-foreground">
          No tienes permiso para acceder a esta vista.
        </p>
      </div>
    );
  }
  return children;
}
